module.exports = __webpack_public_path__ + "static/img/page35.1a7e91e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page35.jpg
// module id = s0tB
// module chunks = 0